<template>
  <div class="-m-2 grid grid-flow-row-dense" :class="[cols, rows]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  cols?: string;
  rows?: string;
}
withDefaults(defineProps<Props>(), {
  cols: 'grid-cols-1',
  rows: '',
});
</script>
